module.exports = __webpack_public_path__ + "img/howto_insurancestaking_metamaskconfirmation.60d4d4f0.png";